import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { PUBLIC_ROUTES, PRIVATE_ROUTES } from '../constants/router/router.constant'
import PublicRouter from '../components/publicRouter'
import PrivateRouter from '../components/privateRouter'
import NotFoundError from '../pages/_error/404'

// Create function to render nested routes
const renderNestedRoutes = (routes: any[]) => {
    return routes.map((route) => {
        if (route.children) {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={<PrivateRouter Element={route.component} Layout={route.layout} allowedRoles={route.allowedRoles} />}
                >
                    {renderNestedRoutes(route.children)}
                </Route>
            )
        }

        return (
            <Route
                key={route.path}
                path={route.path}
                element={<PrivateRouter Element={route.component} Layout={route.layout} allowedRoles={route.allowedRoles} />}
            />
        )
    })
}

function RenderRouter() {
    return (
        <Router>
            <Routes>
                {PUBLIC_ROUTES.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={<PublicRouter Element={route.component} Layout={route.layout} />}
                    />
                ))}

                {renderNestedRoutes(PRIVATE_ROUTES)}
                <Route path="*" element={<NotFoundError />} />
            </Routes>
        </Router>
    )
}

export default RenderRouter